export const AdminCoachPageDynamic = () => import('./components/AdminCoachPage');
export { COACH_MODE_ID } from './constants';
